import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import { Button, LinkTo } from '../../../helpers';

function FavoriteDelete({ item, onDelete, organizationId }) {
  return (
    <div className="row">
      <div className="col-12">
        <div className="alert alert-danger">
          You are about to delete:&nbsp;
          <LinkTo href={`organizations/${organizationId}/favorites/${get(item, 'id')}/show`}>{(get(item, 'name'))}</LinkTo>.&nbsp;
          Are you sure?
        </div>

        <div className="btn-group">
          <LinkTo button icon="times-circle" color="secondary" href="favorites">
            Cancel
          </LinkTo>
          <Button button icon="trash" color="danger" href="favorites" onClick={() => onDelete(get(item, 'id'))}>
            Yes, Delete
          </Button>
        </div>
      </div>
    </div>
  );
}

FavoriteDelete.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string
  }).isRequired,
  onDelete: PropTypes.func.isRequired
};

export default FavoriteDelete;
